import { faUsersViewfinder } from "@fortawesome/pro-regular-svg-icons/faUsersViewfinder";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconUserRestriction: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faUsersViewfinder} />;
};
